import { ApiService } from "src/network/apiService";
import { IUserPermission, IUserPermissionBag } from "./auth-context";

export class PermissionBagService {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async getPermissionBag(roleId: string): Promise<IUserPermissionBag | undefined> {
        const url = `/onboard/${roleId}/permissions`;

        // Call the API to fetch permissions
        const response: any = await this.apiService.getAsync(url);

        if (response?.scResponse?.code === 2000 && Array.isArray(response?.scResponse?.data)) {
            // Extract and map permissions
            const permissions: IUserPermission[] = response.scResponse.data.map((permission: string) => {
                const [name, value] = permission.split(":");
                return { name, value };
            });

            // Construct the permission bag
            const permissionBag: IUserPermissionBag = { permissions };

            return permissionBag;
        }

        // Return undefined if the response is invalid
        return undefined;
    }
}